/**
 * Market making management API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Ws message type dto
 */
export interface WsMessageTypeDto {
  wsMessageType?: WsMessageTypeDto.WsMessageTypeEnum;
}
export namespace WsMessageTypeDto {
  export const WsMessageTypeEnum = {
    Error: 'error',
    KaaliStatus: 'kaali-status',
    SystemStatus: 'system-status',
    KaaliHedgeTrade: 'kaali-hedge-trade',
    KaaliPlatformTrade: 'kaali-platform-trade',
    KaaliBook: 'kaali-book',
    KaaliBalance: 'kaali-balance',
  } as const;
  export type WsMessageTypeEnum = (typeof WsMessageTypeEnum)[keyof typeof WsMessageTypeEnum];
}
